<template>
  <div class="container-fluid mtb15 no-fluid">
    <div class="row sm-gutters">
      <!-- Menu -->
      <div v-if="1200 < getWindowsWidth" class="col-sm-12 col-md-2">
        <AppMenu></AppMenu>
      </div>
      <div class="col-sm-12" :class="{ 'col-md-10': 1200 < getWindowsWidth }">
        <!-- header -->
        <div class="row align-items-center wallet-detail-header">
          <div class="col-sm-1 wallet-detail-back">
            <!-- back button -->
            <button
              class="btn btn btn-outline-secondary btn-light mb-2"
              :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }"
              @click.prevent="goBack()"
            >&larr;</button>
          </div>
          <div class="col-sm-11 wallet-detail-title">
            <!-- view header -->
            <h5 v-if="1200 < getWindowsWidth">{{ getOrdersLabel }} - #{{ orderId }}</h5>
            <h6 v-else>{{ getOrdersLabel }} - #{{ orderId }}</h6>
          </div>
        </div>
        <!-- order details -->
        <div v-if="!orderDetailsLoaded" class="order-details-loading">
          <Preloader />
        </div>
        <div v-else-if="order" class="table-responsive">
          <table class="table order-details-table">
            <tbody>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getStatusLabel }}</td>
                <td
                  class="prop-value"
                  :class="[getOrderStatusClass(order), { 'xsmall-font-size': 1200 > getWindowsWidth }]"
                >
                  {{ getOrderStatus(order) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getOrderIdLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ orderIdentifier }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getTimestampLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ getDate(order?.acquired) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getTypeLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ getOrderType(order?.action) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getOrderTypeLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ getPurchaseType(order?.type) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getCodeLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ order?.code }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getNameLabel }}</td>
                <td
                  v-if="0 === 'BG'.localeCompare(getUserLanguage)"
                  class="prop-value"
                  :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }"
                >
                  {{ order?.nBG ? order?.nBG : order?.nEN }}
                </td>
                <td
                  v-if="0 === 'EN'.localeCompare(getUserLanguage)"
                  class="prop-value"
                  :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }"
                >
                  {{ order?.nEN }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getExchangeLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ orderExchangeCode }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getSegmentLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ order?.segment }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getInstrumentTypeLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ getInstrumentType(order?.stid) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getValidityLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ getValidityDate(order) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getRestrictionLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ getRestriction(order) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getTradeAtCloseLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ getTradeAtClose(order) }}
                </td>
              </tr>
              <tr v-if="hasStopPrice(order)">
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getStopPriceLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ formatOrderLimitPrice(getStopPrice(order)) }}
                </td>
              </tr>
              <tr v-if="hasPeakAmount(order)">
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getPeakLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ formatQuantityOrFaceValue(getPeakAmount(order)) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getQuantityOrFaceValueLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ formatQuantityOrFaceValue(getQuantityOrFaceValue()) }}
                </td>
              </tr>
              <tr v-if="hasLimitPrice(order)">
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getPriceLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ formatOrderLimitPrice(getLimitPrice(order)) }}
                </td>
              </tr>
              <tr v-if="hasLimitPrice(order)">
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getAmountLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ formatPrice(getOrderMoneyAmount(order), order?.cc, 2) }}
                </td>
              </tr>
              <tr>
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getCommissionLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ formatPrice(order?.fee, order?.cc, 2) }}
                </td>
              </tr>
              <tr v-if="hasLimitPrice(order)">
                <td :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">{{ getTotalAmountLabel }}</td>
                <td class="prop-value" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }">
                  {{ formatPrice(getOrderTotalAmount(order), order?.cc, 2) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

import AppMenu from "@/components/ui/AppMenu.vue";
import Preloader from "@/components/ui/Preloader.vue";
import I18n from "@/lang/i18n.js";
import UiUtils from "@/assets/js/ui_utils.js";
import type { Order } from "@/features/wallet/types";
import { fetchOrder } from "@/features/wallet/wallet-api";
import { getOrderActionLabel, getOrderStatusLabel, getPurchaseTypeLabel } from "@/features/wallet/wallet-label-formatters";
import { getStockTypeLabel } from "@/features/stocks/stock-type-labels";

export default {
  components: { AppMenu, Preloader },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const getWindowsWidth = computed(
      () => store.getters["getAppWindowWidth"] || window.innerWidth
    );

    const getOrderIdentifier = (
      currentOrder: Order | null | undefined
    ): string => {
      const rec = currentOrder as Record<string, unknown> | null | undefined;
      if (!rec) {
        return "";
      }

      const keys = ["oid", "order_id", "id", "orderId"] as const;
      for (const key of keys) {
        const value = rec[key];
        if (typeof value === "string" || typeof value === "number") {
          return String(value);
        }
      }

      return "";
    };

    const orderId = computed(() => {
      const fromRoute = route.params.orderId as string | string[] | undefined;
      const selected = store.state.wallet?.selectedOrder as Order | null | undefined;
      const normalizedRouteId = Array.isArray(fromRoute) ? fromRoute[0] : fromRoute;

      return String(normalizedRouteId ?? getOrderIdentifier(selected));
    });

    const getUserLanguage = computed(
      () =>
        (store.getters["getNonLoggedInLanguage"] as string | undefined)?.toUpperCase() ||
        "EN"
    );

    const t = (key: string, ...args: unknown[]): string => {
      return I18n.t(key, getUserLanguage.value, ...args);
    };

    const orderDetailsLoaded = ref(false);

    const orderFormatterLabels = computed(() => ({
      buy: t("buyLabel"),
      sell: t("sellLabel"),
      processing: t("processingLabel"),
      placed: t("placedLabel"),
      cancelled: t("cancelledLabel"),
      filled: t("filledLabel")
    }));

    const purchaseTypeLabels = computed(() => ({
      limit: t("limitLabel"),
      market: t("marketLabel")
    }));

    const stockTypeLabels = computed(() => ({
      bonds: t("bondsLabel"),
      cfd: t("cfdLabel"),
      compInstruments: t("compInstrumentsLabel"),
      equities: t("equitiesLabel"),
      funds: t("fundsLabel"),
      margin: t("marginLabel"),
      netting: t("nettingLabel"),
      reits: t("reitsLabel"),
      repo: t("repoLabel"),
      rights: t("rightsLabel"),
      stocksAndEtfs: t("stocksAndEtfsLabel"),
      other: t("othersLabel"),
      unknown: t("othersLabel")
    }));

    const getDate = (
      value: string | number | Date | null | undefined
    ): string => {
      if (value == null) return "";
      if (value instanceof Date) {
        return UiUtils.parseUnixMsTime(value.getTime());
      }
      if (typeof value === "number") {
        return value < 10_000_000_000
          ? UiUtils.parseUnixTime(value)
          : UiUtils.parseUnixMsTime(value);
      }

      const parsed = Date.parse(value);
      return Number.isNaN(parsed) ? String(value) : UiUtils.parseUnixMsTime(parsed);
    };

    const getDateOnly = (
      value: string | number | Date | null | undefined
    ): string => {
      if (value == null || "" === String(value)) {
        return "";
      }

      if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) {
        return value.slice(0, 10);
      }

      const date = value instanceof Date
        ? value
        : new Date(typeof value === "number" && value < 10_000_000_000 ? value * 1000 : value);
      return Number.isNaN(date.getTime()) ? String(value) : date.toISOString().slice(0, 10);
    };

    const getOrderType = (
      action: string | null | undefined
    ): string => {
      return getOrderActionLabel(action, orderFormatterLabels.value);
    };

    const getPurchaseType = (
      type: string | null | undefined
    ): string => {
      return getPurchaseTypeLabel(type, purchaseTypeLabels.value);
    };

    const formatPrice = (
      val: number | null | undefined,
      curr: string | null | undefined,
      autoDigits?: number
    ): string => {
      return UiUtils.formatPrice(
        val,
        curr,
        getUserLanguage.value,
        autoDigits
      );
    };

    const toNumber = (
      value: number | string | null | undefined
    ): number => {
      if (value == null) {
        return 0;
      }

      const num = typeof value === "string" ? Number(value) : value;
      return Number.isFinite(num) ? num : 0;
    };

    const getOrderField = (
      currentOrder: Order | null | undefined,
      ...keys: string[]
    ): unknown => {
      const rec = currentOrder as Record<string, unknown> | null | undefined;
      if (!rec) {
        return undefined;
      }

      for (const key of keys) {
        const value = rec[key];
        if (value != null && "" !== String(value)) {
          return value;
        }
      }

      return undefined;
    };

    const normalizeOrderType = (
      type: unknown
    ): string => {
      const normalized = String(type ?? "")
        .trim()
        .toUpperCase()
        .replace(/[\s-]+/g, "_");

      switch (normalized) {
        case "1":
          return "MARKET";
        case "2":
          return "LIMIT";
        case "5":
          return "STOP_LIMIT";
        case "10":
          return "STOP_MARKET";
        case "12":
          return "ICEBERG";
        default:
          return normalized;
      }
    };

    const getOrderTypeCode = (
      currentOrder: Order | null | undefined
    ): string => normalizeOrderType(getOrderField(currentOrder, "type", "ot"));

    const isStopOrder = (
      currentOrder: Order | null | undefined
    ): boolean => ["STOP_LIMIT", "STOP_MARKET"].includes(getOrderTypeCode(currentOrder));

    const isIcebergOrder = (
      currentOrder: Order | null | undefined
    ): boolean => "ICEBERG" === getOrderTypeCode(currentOrder);

    const hasPriceBearingLimit = (
      currentOrder: Order | null | undefined
    ): boolean => ["LIMIT", "STOP_LIMIT", "ICEBERG"].includes(getOrderTypeCode(currentOrder));

    const getPositiveNumber = (
      value: unknown
    ): number | null => {
      const numeric = toNumber(value as number | string | null | undefined);
      return numeric > 0 ? numeric : null;
    };

    const orderFromStore = computed<Order | null>(() => {
      const id = orderId.value;
      return id
        ? (store.getters["wallet/orderById"]?.(id) as Order | null | undefined) ?? null
        : null;
    });

    const order = computed<Order | null>(() => {
      const selected = store.state.wallet?.selectedOrder as Order | null | undefined;
      const id = orderId.value;
      const byId = orderFromStore.value;

      if (byId) {
        return {
          ...((selected as Record<string, unknown> | null) ?? {}),
          ...(byId as Record<string, unknown>)
        } as unknown as Order;
      }

      if (selected && (!id || getOrderIdentifier(selected) === id)) {
        return selected;
      }

      return null;
    });

    const hasFullOrderDetails = (
      currentOrder: Order | null | undefined
    ): boolean => {
      const rec = currentOrder as Record<string, unknown> | null | undefined;
      if (!rec) {
        return false;
      }

      return true === rec._detailsLoadedFromGetOrder;
    };

    const loadOrderDetails = async () => {
      if (!orderId.value || hasFullOrderDetails(orderFromStore.value)) {
        orderDetailsLoaded.value = true;
        return;
      }

      const user = store.getters["getUser"];
      const userType = store.getters["getUserType"];
      try {
        const res = await fetchOrder(userType, user, orderId.value);
        if (res?.data?.ec === 0) {
          store.commit("wallet/upsertOrder", {
            ...((orderFromStore.value as Record<string, unknown> | null) ?? {}),
            ...res.data,
            oid: res.data.oid ?? res.data.order_id ?? res.data.id ?? orderId.value,
            order_id: res.data.order_id ?? res.data.oid ?? res.data.id ?? orderId.value,
            _detailsLoadedFromGetOrder: true,
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        orderDetailsLoaded.value = true;
      }
    };

    onMounted(loadOrderDetails);
    watch(orderId, () => {
      orderDetailsLoaded.value = false;
      void loadOrderDetails();
    });

    const orderIdentifier = computed(() => getOrderIdentifier(order.value));

    const isBondOrder = computed(() => 2 === Number.parseInt(String(order.value?.stid ?? ""), 10));

    const orderExchangeCode = computed(() => {
      const rec = order.value as Record<string, unknown> | null | undefined;
      if (!rec) {
        return "";
      }

      const value = rec.xcode ?? rec.xc ?? rec.exchange ?? rec.ex;
      return value == null ? "" : String(value);
    });

    const getOrderStatus = (
      currentOrder: Order | null | undefined
    ): string => {
      return getOrderStatusLabel(currentOrder, orderFormatterLabels.value);
    };

    const getOrderStatusClass = (
      currentOrder: Order | null | undefined
    ): string => {
      const status = Number.parseInt(String(currentOrder?.status ?? ""), 10);

      if ([1, 2, 12, 99].includes(status)) {
        return "order-status-processing";
      }

      if (3 === status) {
        return "order-status-placed";
      }

      if ([6, 7].includes(status)) {
        return "order-status-filled";
      }

      if ([4, 5].includes(status)) {
        return "order-status-cancelled";
      }

      return "order-status-default";
    };

    const getInstrumentType = (
      stockType: number | string | null | undefined
    ): string => {
      return getStockTypeLabel(stockType, stockTypeLabels.value);
    };

    const getValidityDate = (
      currentOrder: Order | null | undefined
    ): string => {
      const rec = currentOrder as Record<string, unknown> | null | undefined;
      const value = rec?.exp_date ?? rec?.expiry_date ?? rec?.valid_until;
      return getDateOnly(value as string | number | Date | null | undefined);
    };

    const getRestriction = (
      currentOrder: Order | null | undefined
    ): string => {
      const rec = currentOrder as Record<string, unknown> | null | undefined;
      const value = rec?.rest_code ?? rec?.restriction ?? rec?.restrictions;
      return value == null || "" === String(value) ? t("noRestrictionsLabel") : String(value);
    };

    const getTradeAtClose = (
      currentOrder: Order | null | undefined
    ): string => {
      const rec = currentOrder as Record<string, unknown> | null | undefined;
      return true === rec?.tac ? t("yesLabel") : t("noLabel");
    };

    const getStopPrice = (
      currentOrder: Order | null | undefined
    ): number | null => {
      return getPositiveNumber(getOrderField(currentOrder, "stop", "stop_price", "stopPrice"));
    };

    const hasStopPrice = (
      currentOrder: Order | null | undefined
    ): boolean => {
      return isStopOrder(currentOrder) && getStopPrice(currentOrder) != null;
    };

    const getPeakAmount = (
      currentOrder: Order | null | undefined
    ): number | null => {
      return getPositiveNumber(getOrderField(currentOrder, "peak", "peak_amount", "peakAmount"));
    };

    const hasPeakAmount = (
      currentOrder: Order | null | undefined
    ): boolean => {
      return isIcebergOrder(currentOrder) && getPeakAmount(currentOrder) != null;
    };

    const getLimitPrice = (
      currentOrder: Order | null | undefined
    ): number | null => {
      return getPositiveNumber(getOrderField(currentOrder, "price", "pr"));
    };

    const hasLimitPrice = (
      currentOrder: Order | null | undefined
    ): boolean => {
      return hasPriceBearingLimit(currentOrder) && getLimitPrice(currentOrder) != null;
    };

    const hasBondFaceValueDetails = (
      currentOrder: Order | null | undefined
    ): boolean => {
      const rec = currentOrder as Record<string, unknown> | null | undefined;
      if (!rec) {
        return false;
      }

      return rec.amount != null && (rec.nom != null || rec.nominal != null) && (rec.innom != null || rec.initialnominal != null);
    };

    const getQuantityOrFaceValue = (): number | null => {
      const currentOrder = order.value;
      if (!currentOrder) {
        return 0;
      }

      const amount = toNumber(currentOrder.amount as number | string | undefined);
      if (!isBondOrder.value) {
        return amount;
      }

      if (!hasBondFaceValueDetails(currentOrder)) {
        return null;
      }

      return UiUtils.getBondDisplayFaceValue(currentOrder, amount);
    };

    const formatQuantityOrFaceValue = (
      value: number | null
    ): string => {
      if (value == null) {
        return "";
      }
      return UiUtils.formatNumber(value, Number.isInteger(value) ? 0 : 2);
    };

    const formatOrderLimitPrice = (
      value: number | null
    ): string => {
      return isBondOrder.value
        ? formatPrice(value, "%", 4)
        : formatPrice(value, order.value?.cc, 4);
    };

    const getOrderMoneyAmount = (
      currentOrder: Order | null | undefined
    ): number => {
      return UiUtils.getOrderEstimatedAmountAsMoney(currentOrder);
    };

    const getOrderTotalAmount = (
      currentOrder: Order | null | undefined
    ): number => {
      const amount = getOrderMoneyAmount(currentOrder);
      const fee = toNumber(currentOrder?.fee as number | string | null | undefined);
      const action = String(getOrderField(currentOrder, "action", "act") ?? "").toUpperCase();

      return "S" === action || "SELL" === action ? amount - fee : amount + fee;
    };

    const goBack = () => {
      const fromQuery = route.query.latestActiveMenuSelection;
      const latestActiveMenuSelection =
        typeof fromQuery === "string" ? fromQuery : "Orders";

      router.push({
        name: "Wallet",
        query: { latestActiveMenuSelection }
      });
    };

    // label computeds
    const getOrdersLabel = computed(() => t("ordersLabel"));
    const getStatusLabel = computed(() => t("statusLabel"));
    const getOrderIdLabel = computed(() => t("orderLabel"));
    const getTimestampLabel = computed(() => t("timestampLabel"));
    const getTypeLabel = computed(() => t("typeLabel"));
    const getOrderTypeLabel = computed(() => t("orderTypeLabel"));
    const getCodeLabel = computed(() => t("codeLabel"));
    const getNameLabel = computed(() => t("nameLabel"));
    const getExchangeLabel = computed(() => t("exchangeLabel"));
    const getSegmentLabel = computed(() => t("segmentLabel"));
    const getInstrumentTypeLabel = computed(() => t("instrumentTypeLabel"));
    const getValidityLabel = computed(() => t("validityLabel"));
    const getRestrictionLabel = computed(() => t("restrictionLabel"));
    const getTradeAtCloseLabel = computed(() => t("tradeAtCloseLabel"));
    const getStopPriceLabel = computed(() => t("stopPriceLabel"));
    const getPeakLabel = computed(() => t("peakLabel"));
    const getQuantityOrFaceValueLabel = computed(() => isBondOrder.value ? t("faceValueLabel") : t("quantityLabel"));
    const getPriceLabel = computed(() => t("priceLabel"));
    const getAmountLabel = computed(() => t("amountLabel"));
    const getCommissionLabel = computed(() => t("commissionLabel"));
    const getTotalAmountLabel = computed(() => t("totalAmountLabel"));

    return {
      // navigation & ids
      orderId,
      order,
      orderIdentifier,
      goBack,

      // layout
      getWindowsWidth,
      orderDetailsLoaded,

      // language and labels
      getUserLanguage,
      getOrdersLabel,
      getStatusLabel,
      getOrderIdLabel,
      getTimestampLabel,
      getTypeLabel,
      getOrderTypeLabel,
      getCodeLabel,
      getNameLabel,
      getExchangeLabel,
      getSegmentLabel,
      getInstrumentTypeLabel,
      getValidityLabel,
      getRestrictionLabel,
      getTradeAtCloseLabel,
      getStopPriceLabel,
      getPeakLabel,
      getQuantityOrFaceValueLabel,
      getPriceLabel,
      getAmountLabel,
      getCommissionLabel,
      getTotalAmountLabel,

      // helpers
      getDate,
      getOrderType,
      getPurchaseType,
      formatPrice,
      orderExchangeCode,
      getOrderStatus,
      getOrderStatusClass,
      getInstrumentType,
      getValidityDate,
      getRestriction,
      getTradeAtClose,
      getStopPrice,
      hasStopPrice,
      getPeakAmount,
      hasPeakAmount,
      getQuantityOrFaceValue,
      formatQuantityOrFaceValue,
      formatOrderLimitPrice,
      getLimitPrice,
      hasLimitPrice,
      getOrderMoneyAmount,
      getOrderTotalAmount,
    };
  },
};
</script>

<style scoped>
.wallet-detail-header {
  flex-wrap: nowrap;
}

.wallet-detail-back {
  flex: 0 0 auto;
  width: auto;
}

.wallet-detail-title {
  flex: 1 1 auto;
  width: auto;
}

.wallet-detail-title h5,
.wallet-detail-title h6 {
  margin-bottom: 0.5rem;
}

.order-details-loading {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 8rem);
  width: 100%;
}

.prop-value {
  text-align: right;
  font-weight: bold;
}

.order-details-table td {
  font-size: 1rem;
  line-height: 1.35;
  padding: 0.6rem 0.5rem;
}

.order-status-processing {
  color: #2a7aff;
}

.order-status-placed {
  color: #2a7aff;
}

.order-status-filled {
  color: green;
}

.order-status-cancelled {
  color: red;
}

.order-status-default {
  color: black;
}

.xxsmall-font-size {
  font-size: xx-small;
}

.xsmall-font-size {
  font-size: 1rem;
}
</style>
